import { Stack, Switch, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReuseTooltip } from "../../ui";
import { useSixsensSubscriptionMutation } from "../../../api";
import { toast } from "react-toastify";
import { CustomToast } from "../../ui/CustomToast";
import { getErrorMessage } from "../../../utils/getErrorMessage";
import { useDebounceValue } from "../../../hooks";

const tooltip =
  "This option can be turned on or off only by users who have edit access.";

export const SixSensBlock = ({
  isDisabled,
  campaign_id,
  isSubscribed,
}: {
  isDisabled?: boolean;
  campaign_id: string;
  isSubscribed: boolean;
}) => {
  const [currentSubscription, setCurrentSubscription] =
    useState<boolean>(false);
  const [subscription, setSubscription] = useState<boolean>(isSubscribed);
  const [subscribeTrigger, setSubscribeTrigger] = useState<number>(0);
  const [sixsensSubscription] = useSixsensSubscriptionMutation();

  const debounceSubscribeTrigger = useDebounceValue(subscribeTrigger, 500);

  const changeSubscription = () => {
    sixsensSubscription({ campaign_id, subscription })
      .unwrap()
      .then(() => setCurrentSubscription(subscription))
      .catch((err) => {
        toast.error(
          <CustomToast
            type={"error"}
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
            title={"Something went wrong"}
          />,
        );
        setSubscribeTrigger(0);
        setSubscription(currentSubscription);
      });
  };

  useEffect(() => {
    if (debounceSubscribeTrigger) changeSubscription();
  }, [debounceSubscribeTrigger]);

  return (
    <Stack>
      <Stack
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row",
          gap: "16px",
        }}
      >
        <Typography
          component="span"
          variant="subtitle1"
          sx={{ color: "#232323", fontWeight: 600 }}
        >
          Subscribe to 6sense Partner Data
        </Typography>
        <ReuseTooltip
          text={isDisabled ? tooltip : ""}
          hideChildren={false}
          maxWidth={"184px"}
        >
          <Switch
            disabled={isDisabled}
            checked={subscription}
            onChange={() => {
              setSubscription(!subscription);
              setSubscribeTrigger(Date.now());
            }}
          />
        </ReuseTooltip>
      </Stack>
      <Typography
        component="span"
        variant="subtitle1"
        sx={{ color: "#464646", maxWidth: "330px" }}
      >
        Get biweekly updates for this campaign from 6sense.
      </Typography>
    </Stack>
  );
};
